export function getPanelLowerStyles() {
	// pull from commonStyles if wanted here
	return {
		yAxis: {
			padding: {
				top: 4,
				bottom: 4
			}
		}
	};
}
